module.exports = __webpack_public_path__ + "media/images/weather/341_day-e9e449c5255e63901d20594e448df477.png";